import React from 'react';
import { Typography, Box } from '@mui/material';



const ParaContent = (props) => {
    

    return <Typography align='justify' sx={{ fontSize: "16px",  marginTop: props.noMargin ? "0px" : "20px" }}>{props.content} </Typography>
}

export default ParaContent;